import { ChangeDetectorRef, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HecResponse } from '../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { CommonHelper } from '../../../../core/_config/common.helper';
import { LetterIssueService } from './services/letter-issue.service';
import { LoaderService } from '../../../../shared/sharedServices/loader.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'kt-letter-issue',
  templateUrl: './letter-issue.component.html',
  styleUrls: ['./letter-issue.component.css']
})
export class LetterIssueComponent implements OnInit {
	headerLogo: string = "./assets/media/logos/logo-2.png";
  public letterText:any;
  public letterList:any;
  public desDegreeId:any;
  public degreeTitle:any;
  public university:any;
  public appId:any;
  public loader:boolean;
  public imageContent:any;
  public imageType:string;
  public letterType: any = [{ label:"Final Letter" , value:0,},{ label:"Provisional Letter", value:1 }]
  @ViewChild('letterissueForm',{static:false}) letterissueForm: NgForm;
  model: any = {};
  public leterValue:number;
  showTemplateType: boolean =false;
  constructor(private dialogRef: MatDialogRef<LetterIssueComponent>,@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private letterIssueService:LetterIssueService,private loaderService:LoaderService,
  private cdr:ChangeDetectorRef,private dom:DomSanitizer, public router:Router) { }

  async ngOnInit() {
    console.log(this.router.url.split('/')[1])
    if(this.router.url.split('/')[2] == HEC_CONSTANTS.DES_URLS.LOCAL_DES_ADMIN){
    await this.getLetterList('des')
    }
    else if(this.router.url.split('/')[1] == HEC_CONSTANTS.DES_URLS.DES_FINAL_LETTER)
    {
      await this.getLetterList('des')
      this.letterType = [{ label:"Final Letter" , value:0}]
      this.cdr.detectChanges()
    }



    else if(this.router.url.split('/')[2] == HEC_CONSTANTS.DES_URLS.FOREIGN_DES_ADMIN){
      console.log('runs 39')
      console.log(this.data);
      // await this.getLetterList('desf')
      let pdfdata=this.data.pdf
    this.imageContent = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,'+pdfdata);
    this.imageType = 'pdf'
    this.cdr.detectChanges();
    }
    this.appId = this.data.appId;
    if (this.data.model) {
      console.log(this.data.model)
      this.model.letterId = this.data.model.letterId || '';
      this.model.desDegreeId = this.data.model.desDegree.id || '';
      this.model.degNameByAdmin = this.data.model.degNameByAdmin || '';
      this.model.degreeTitle = this.data.model.degreeProgramName || '';
      this.model.university = this.data.model.universityName || '';
      this.model.uniNameByAdmin = this.data.model.uniNameByAdmin || '';
      this.model.uniNameOnDegree = this.data.model.desDegree.uniNameOnDegree || '',
      this.model.exactDegreeName = this.data.model.desDegree.exactDegreeName || '',
      this.model.yearOfSchoolingByAdmin = this.data.model.yearOfSchoolingByAdmin || '';
      this.model.majorByAdmin = this.data.model.majorByAdmin || '';
      this.model.campusByAdmin = this.data.model.campusByAdmin || '';
      this.model.degTitleByAdmin = this.data.model.degTitleByAdmin || '';
      this.model.showMajor = this.data.model.showMajor || false;
      this.model.studyStream = this.data.model.studyStream || '';
      this.model.disabledLetterSelection = this.data.model.disabledLetterSelection || false;
      this.model.isEditable = this.data.isEditable;


      console.log(this.data.model, this.model)
      if(this.data.model.letterId && this.router.url.split('/')[2] == HEC_CONSTANTS.DES_URLS.LOCAL_DES_ADMIN){
      this.leterValue = +this.data.model.letterId
      this.getSelectedLetter(+this.data.model.letterId)
    }

    if(this.router.url.split('/')[2] == HEC_CONSTANTS.DES_URLS.FOREIGN_DES_ADMIN){
    // this.getSelectedLetter(10021)
      
    }

    console.log(this.letterType, this.letterList)
    
    }
  }

  public async getLetterList(acronym):Promise<void>{
    this.loader = true;
    const res = await this.letterIssueService.getTemplateList(acronym).toPromise();
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
          this.letterList = res.data;
          this.loader=false;
      }else{
        this.loader=false;
        this.cdr.detectChanges();

      }
    
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  // public submitLetter(){[
  //   this.dialogRef.close(this.letterText)
  // ]}

  public getSelectedLetter(value){
    this.loader=true;
    let acronym;
    if(this.router.url.split('/')[2] == "foreigntask-detail"){
      acronym = 'desf'
    }else if(this.router.url.split('/')[2] == "task-detail" || this.router.url.split('/')[1] == 'des-final-letter'){
      acronym = 'des'
    }
    console.log(this.model)
    this.imageContent = undefined;
    // this.loaderService.setValue(true);
    let paylaod ={}
    if(this.router.url.split('/')[2] == "foreigntask-detail"){
    
     
    paylaod = {
      data:{
        desDegreeId:this.model.desDegreeId,
        letterId:value,
        degreeTitle:this.model.degreeTitle,
        degNameByAdmin:this.model.degNameByAdmin,
        university:this.model.university,
        uniNameByAdmin:this.model.uniNameByAdmin,
        campusByAdmin:this.model.campusByAdmin,
        majorByAdmin:this.model.majorByAdmin,
        yearOfSchoolingByAdmin:this.model.yearOfSchoolingByAdmin,
        showMajor:this.model.showMajor,
        degTitleByAdmin:this.model.degTitleByAdmin,
        studyStream:this.model.studyStream

      }}
    }else if(this.router.url.split('/')[2] == "task-detail"){
      console.log(this.model)
      paylaod = {
        data:{
          desDegreeId:this.model.desDegreeId,
          letterId:value,
          isProvisional: this.letterissueForm.form.value.isProvisional,
          degreeTitle:this.model.degreeTitle,
          degNameByAdmin:this.model.degNameByAdmin,
          university:this.model.university,
          // uniNameByAdmin:this.model.uniNameByAdmin,
          // campusByAdmin:this.model.campusByAdmin,
          // majorByAdmin:this.model.majorByAdmin,
          // yearOfSchoolingByAdmin:this.model.yearOfSchoolingByAdmin,
          // showMajor:this.model.showMajor,
          // degTitleByAdmin:this.model.degTitleByAdmin,
          // studyStream:this.model.studyStream
  
        }}
    }

    else if(this.router.url.split('/')[1] == 'des-final-letter'){
      console.log(this.model)
      paylaod = {
        data:{
          desDegreeId:this.model.desDegreeId,
          letterId:value,
          isProvisional: this.letterissueForm.form.value.isProvisional,
          degNameByAdmin:this.model.degNameByAdmin,
          degreeTitle: this.model.exactDegreeName,
          university: this.model.uniNameOnDegree
  
        }}
    }
    
    this.letterIssueService.generateLetter(this.appId,paylaod,acronym).subscribe(
      (res)=>{
        if(res.statusCode==HEC_CONSTANTS.HTTP_RESPONSE.OK){
        this.loader=false;
        // this.loaderService.setValue(this.loader);
          // this.imageContent = res.data;
          this.imageType = 'pdf'
          this.imageContent = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,'+res.data);
          this.cdr.detectChanges();
        }else{
        this.loader=false;
        // this.loaderService.setValue(this.loader);
          this.cdr.detectChanges();
        }
      },
      (err)=>{
          this.loader=false;
          // this.loaderService.setValue(this.loader);
            this.cdr.detectChanges();
          }
    )
  }

  submitLetter():void{
    if(this.router.url.split('/')[2] == 'task-detail'){
    CommonHelper.markFormGroupTouched(this.letterissueForm);
    console.log(this.letterissueForm)
    if(this.validate(this.letterissueForm)){
      // this.letterText = this.letterList.find(d => d.value == this.letterissueForm.value.tepmplateId).label
      this.letterText = this.letterissueForm.value.tepmplateId
      console.log(this.letterText)
    this.dialogRef.close(this.letterText)
  }
  }
  else if( this.router.url.split('/')[1] == 'des-final-letter')
  {
    this.letterIssueService.saveDesFinalLetter(this.appId,'des').subscribe(
      (res)=>{
        if(res.statusCode==HEC_CONSTANTS.HTTP_RESPONSE.OK){
        console.log(res)  
        this.loader=false;
        this.cdr.detectChanges();
        this.dialogRef.close(true)
        }else{
        this.loader=false;
        this.cdr.detectChanges();
        this.dialogRef.close(false)
        }
      },
      (err)=>{
          this.loader=false;
          this.cdr.detectChanges();
          this.dialogRef.close(false)
          }
    )
  }
  else{
  // this.letterText = 10021;
  this.dialogRef.close(true)
  }
  }
  public validate(f): boolean {
    if (f.status === 'VALID') {
      return true;
    }
  }

  public getTemplateDropdown(event)
  {
    this.showTemplateType = true
    if(this.showTemplateType) this.letterissueForm.form.controls.tepmplateId.reset()
  }
}
